import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import {
  SharedModule,
  DataService,
  ServerConfigService,
  LanguageCode,
} from "@bb-vendure/admin-ui/core";
import { OnInit, Component } from "@angular/core";

@Component({
  selector: "email-templates",
  standalone: true,
  templateUrl: "./templates.component.html",
  styleUrls: ["./templates.component.scss"],
  imports: [SharedModule],
})
export default class EmailTemplatesComponent implements OnInit {
  constructor(
    protected dataService: DataService,
    private translate: TranslateService,
    protected serverConfigService: ServerConfigService
  ) {}

  ngOnInit(): void {
    this.availableLanguageCodes$ =
      this.serverConfigService.getAvailableLanguages();
  }

  availableLanguageCodes$: Observable<LanguageCode[]>;

  emailEvents = Object.entries(events).map(([key, value]) => ({
    name: `email.${value}`,
    value,
  }));

  translateName(name: string) {
    return this.translate.instant(`email.${name}`);
  }
}

export const events = {
  orderShipping: "order-shipping",
  orderDelivered: "order-delivered",
  orderCancelled: "order-cancelled",
  orderSuccess: "order-success",
  fanClubRequest: "fc-req",
  fanClubAdded: "fc-added",
  fanClubRemoved: "fc-removed",
  fanClubApprove: "fc-approve",
  fanClubReject: "fc-reject",
  questionPost: "question-post",
  cooperateApprove: "cooperate-approve",
  fanClubAdminAdded: "fc-admin-added",
  fanClubAdminRemoved: "fc-admin-removed",
  levelUp: "level-up",
  refund: "refund",
  refundApprove: "refund-approve",
  passwordReset: "password-reset",
  register: "register",
  artistRelease: "artist-release",
  eventStockShortage: "event-stock-shortage"
};
